import { useLoaderData } from '@remix-run/react'
import type { MouseEvent } from 'react'
import { useCallback, useState } from 'react'
import useSearchParamValues from "~/hooks/useSearchParamValues"
import type { FamilyAdItem, SearchResponse } from '~/modules/family/types'

import { SliderSizes, SliderVariants } from '@gotamedia/fluffy/components/Slider'
import useViewSize from '~/hooks/useViewSize'
import { ItemType } from '~/services/resolvers/types'
import NoResults from '../NoResults/NoResults'
import * as Styled from './style'
import type * as Types from './types'

const FamilyWidgetCards: Types.FamilyWidgetCardsComponent = (props: Types.FamilyWidgetCardProps) => {
    const { legacy } = useSearchParamValues(['legacy'])
    const legacyMode = legacy === "true"

    const [index, setIndex] = useState(0)
    const [clientX, setClientX] = useState(0)
    const [hover, setHover] = useState(false)

    const data = useLoaderData<SearchResponse>()
    const { isSmall, isMedium, isLarge } = useViewSize()


    const { width } = props
    const items: FamilyAdItem[] = (data._type &&  data._type === ItemType.MemorialAd ? data.payload?.memorial?.ads :  data.payload?.family?.ads) || []
    const urlType: string = data._type &&  data._type === ItemType.MemorialAd ? "minnas/" :  "fira/"

    const chunk = (arr:FamilyAdItem[] , size: number) =>
        Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
            arr.slice(i * size, i * size + size)
        )

    const updateClientX = useCallback((clientX: number) => {
        setClientX(clientX)
    }, [])

    const updateIndex = useCallback((newIndex: number) => {
        setIndex(newIndex)
    }, [])

    const dragOrClick = useCallback((event: MouseEvent, urlType: string, uuid: string ) => {
        if (event.clientX < clientX + 5 && event.clientX > clientX - 5) {
            window.open(`/${urlType}${uuid}`)
        }
    }, [clientX])

    const chunkSize = width && width > 0 ? Math.floor(width / 170) : isLarge() ? 4 : !isSmall() ? 3 : 2
    const height = legacyMode ? isSmall() ? 306 : 308 : isSmall() ? 376 : 256
    const result = items ? chunk(items, chunkSize) : []

    return (
        <Styled.SliderContainer>
            {result.length > 0 ? (
                <Styled.Slider
                    legacy={legacyMode}
                    width={width || 0}
                    index={index}
                    variant={SliderVariants.Contrast}
                    size={SliderSizes.Small}
                    onChange={(newIndex: number) => updateIndex(newIndex)}
                    onMouseDown={(e: MouseEvent) => updateClientX(e.clientX)}
                    loop={false}
                    slidesCount={result.length}
                    onMouseEnter={() => setHover(true)}
                    onMouseLeave={() => setHover(false)}
                    shouldAutoPlay={false}
                    dynamicBullets={!isLarge()}
                >
                    <Styled.SliderStiles slideProps={{ style: { margin: "0 auto", width: "auto" }}}>

                        {result.map((item, idx) => {
                            return (
                                <Styled.CardContainer key={`${idx}`}>
                                    {
                                        item.map((it: FamilyAdItem, idx) => {
                                            return (
                                                <Styled.CardWrapper
                                                    legacy={legacyMode}
                                                    width={width ? (((width-chunkSize-24) / chunkSize)-10) : undefined}
                                                    type={data._type}
                                                    onMouseUp={(e) => dragOrClick(e, urlType, it.uuid)}
                                                    key={`${it.uuid}-${idx}`}>
                                                    <Styled.ImageContainer>
                                                        <Styled.CardImage
                                                            type={data._type}
                                                            src={it.main_image}
                                                            legacy={legacyMode}
                                                        />
                                                    </Styled.ImageContainer>
                                                </Styled.CardWrapper>
                                            )
                                        })

                                    }
                                </Styled.CardContainer>
                            )
                        })}
                    </Styled.SliderStiles>
                    {
                        items?.length > chunkSize ? (
                            <>
                                <Styled.Slider.SliderBullets />

                                {
                                    (isLarge() || isMedium() && !legacyMode) && hover ? (
                                        <Styled.Slider.Navigation />
                                    ) : (
                                        null
                                    )
                                }
                            </>
                        ) : (
                            null
                        )
                    }
                </Styled.Slider>
            ) : (
                <NoResults heigth={height} type={data._type} width={width}/>
            )}

        </Styled.SliderContainer>
    )
}

export default FamilyWidgetCards
